module.exports = __webpack_public_path__ + "static/pt-sans-v12-latin-regular-8792a07fbb91f86b18b5d1dbd895443f.woff2";